"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useQuestionnaireNavigation = exports.useProgressPercentage = exports.getNextQuestionIndex = void 0;
var _react = require("react");
var _questionnaireActions = require("../../store/questionnaire/questionnaireActions");
var _uiActions = require("../../store/ui/uiActions");
var _questionnaireSelectors = require("../../store/questionnaire/questionnaireSelectors");
var _constants = require("../../utils/constants");
var _questionnaireUtil = require("../../utils/questionnaireUtil");
var _questionnaireMetadataHelper = require("./helpers/questionnaireMetadataHelper");
var _questionSummaryHelper = require("./helpers/questionSummaryHelper");
var _services = require("../../services");
var _uiSelectors = require("../../store/ui/uiSelectors");
var _useAppDispatch = require("../useAppDispatch");
var _useAppSelector = require("../useAppSelector");
const getAreSelectionsValid = (question, selections) => {
  if ((question === null || question === void 0 ? void 0 : question.type) === _constants.QUESTION_TYPE.MULTI) {
    // selections should be equal or more than multi item - every item is a different component.
    return selections.filter(sel => sel !== undefined).length >= question.multi.length;
  }
  if ((question === null || question === void 0 ? void 0 : question.type) === _constants.QUESTION_TYPE.ADDRESS_SEARCH) {
    return selections[0] && Object.values(selections[0]).filter(Boolean).length > 1;
  }
  return selections.length > 0;
};
const getNextQuestionIndex = (questions, currentQuestionIndex, flags, skippedQuestionIds) => {
  let nextQuestionIndex = currentQuestionIndex + 1;
  while (nextQuestionIndex < questions.length) {
    const question = questions[nextQuestionIndex];
    const checkFlag = (question.if && flags[question.if] && !question.unless || question.unless && !flags[question.unless] && !question.if || question.unless && question.if && flags[question.if] && !flags[question.unless] || !question.unless && !question.if) && !(skippedQuestionIds !== null && skippedQuestionIds !== void 0 && skippedQuestionIds.includes(question.id));
    if (checkFlag) {
      return nextQuestionIndex;
    }
    console.log(`Skipping ${nextQuestionIndex}`);
    nextQuestionIndex++;
  }
  return _constants.RECOMMENDATION_PAGE_INDEX;
};
exports.getNextQuestionIndex = getNextQuestionIndex;
const filterQuestions = _ref => {
  let {
    question,
    flags,
    enabledFlags,
    skippedQuestionIds
  } = _ref;
  return (question.if && flags[question.if] && !question.unless || question.unless && !flags[question.unless] && !question.if || question.unless && question.if && flags[question.if] && !flags[question.unless] || !question.unless && !question.if || (enabledFlags === null || enabledFlags === void 0 ? void 0 : enabledFlags.includes(question.if)) && !(enabledFlags !== null && enabledFlags !== void 0 && enabledFlags.includes(question.unless))) && !skippedQuestionIds.includes(question.id);
};
const useQuestionnaireNavigation = () => {
  var _getQuestionnaireMeta;
  const dispatch = (0, _useAppDispatch.useAppDispatch)();
  const questions = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectQuestions);
  const skippedQuestionIds = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectSkippedQuestionIds);
  const currentQuestion = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectCurrentQuestion);
  const currentQuestionIndex = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectCurrentQuestionIndex);
  const currentSelections = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectCurrentSelections);
  const hasValidSelections = getAreSelectionsValid(currentQuestion, currentSelections);
  const answers = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectQuestionnaireAnswers);
  const isFirstQuestion = currentQuestionIndex === 0;
  const isBudgetAdjusted = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectIsBudgetAdjusted);
  const skipMetadata = (0, _questionnaireUtil.isBudgetQuestion)(currentQuestion) && !isBudgetAdjusted;
  const currentPage = (0, _useAppSelector.useAppSelector)(_uiSelectors.selectCurrentPage);
  const handset = _services.locale.localeString('ProgressBar.journey.j1');
  const plan = _services.locale.localeString('ProgressBar.journey.j3');
  const handsetsAndPlans = _services.locale.localeString('ProgressBar.journey.j2');
  // const mixedPlan = locale.localeString('ProgressBar.journey.j4');

  //--------------------total number of journey and action -----------
  let initialValue = {};
  switch (true) {
    case currentSelections.length <= 0:
      break;
    case currentSelections == handsetsAndPlans:
      initialValue = {
        'both-flow': true
      };
      break;
    case currentSelections == plan:
      initialValue = {
        plan: true
      };
      break;
    default:
      initialValue = {
        phone: true,
        'help-me-choose': true
      };
      break;
  }
  const flags = currentQuestion ? (_getQuestionnaireMeta = (0, _questionnaireMetadataHelper.getQuestionnaireMetadata)(currentQuestion, currentSelections, answers, skipMetadata)) === null || _getQuestionnaireMeta === void 0 ? void 0 : _getQuestionnaireMeta.flags : initialValue;
  const getNameOfJourney = () => {
    if (flags['both-flow']) {
      return handsetsAndPlans;
    }
    if (flags.plan) {
      return plan;
    }
    return handset;
  };
  const nameOfJourney = flags && getNameOfJourney();
  const handleFirstQuestionJourneyQuestions = () => {
    const filteredQuestions = questions.filter(question => {
      return !question.if || (flags ? filterQuestions({
        question,
        flags,
        skippedQuestionIds
      }) : false);
    });
    const enabled = filteredQuestions.flatMap(q => {
      var _q$choices, _q$choices$find, _q$choices2, _q$choices2$find;
      return ((_q$choices = q.choices) === null || _q$choices === void 0 ? void 0 : (_q$choices$find = _q$choices.find(c => c.text == currentSelections)) === null || _q$choices$find === void 0 ? void 0 : _q$choices$find.enable) || ((_q$choices2 = q.choices) === null || _q$choices2 === void 0 ? void 0 : (_q$choices2$find = _q$choices2.find(c => {
        var _c$enable;
        return c.isDefault && !((_c$enable = c.enable) !== null && _c$enable !== void 0 && _c$enable.includes(_constants.FLAGS.NEXT_FLOW));
      })) === null || _q$choices2$find === void 0 ? void 0 : _q$choices2$find.enable) || false;
    });
    const finalQuestions = questions.filter(question => flags ? filterQuestions({
      question,
      flags,
      enabledFlags: enabled.filter(Boolean),
      skippedQuestionIds
    }) : false);
    return finalQuestions;
  };
  const JourneyQuestions = (0, _react.useMemo)(() => isFirstQuestion ? handleFirstQuestionJourneyQuestions() : questions.filter(question => {
    var _currentQuestion$choi, _currentQuestion$choi2;
    return !question.if || (flags ? filterQuestions({
      question,
      flags,
      enabledFlags: currentQuestion === null || currentQuestion === void 0 ? void 0 : (_currentQuestion$choi = currentQuestion.choices) === null || _currentQuestion$choi === void 0 ? void 0 : (_currentQuestion$choi2 = _currentQuestion$choi.find(c => c.text == currentSelections)) === null || _currentQuestion$choi2 === void 0 ? void 0 : _currentQuestion$choi2.enable,
      skippedQuestionIds
    }) : false);
  }), [currentQuestion, questions, flags, currentSelections]);
  const currentJourneyQuestionIndex = (0, _react.useMemo)(() => JourneyQuestions.findIndex(question => {
    return (question === null || question === void 0 ? void 0 : question.title) === (currentQuestion === null || currentQuestion === void 0 ? void 0 : currentQuestion.title);
  }), [JourneyQuestions, currentQuestion]);
  (0, _react.useEffect)(() => {
    if (currentJourneyQuestionIndex !== -1) dispatch((0, _questionnaireActions.setQuestionIndexInFlow)(currentJourneyQuestionIndex));
  }, [currentJourneyQuestionIndex]);
  const totalNumberOfJourneyQuestions = currentSelections.length == 0 && isFirstQuestion ? questions.length : JourneyQuestions === null || JourneyQuestions === void 0 ? void 0 : JourneyQuestions.length;
  //--------------------total number of journey and action -----------

  const onRestart = () => {
    dispatch((0, _questionnaireActions.resetQuestionnaire)());
  };
  const onRestartWithWarningMessage = () => {
    dispatch((0, _uiActions.setPrevPage)(currentPage));
    dispatch((0, _uiActions.setDynamicPageContent)(_constants.DYNAMIC_PAGES.WARNING_SCREEN));
    dispatch((0, _uiActions.goToDynamicPage)());
  };
  const onBack = () => {
    dispatch((0, _questionnaireActions.gotoPreviousQuestion)());
  };
  const onNext = () => {
    const metadata = (0, _questionnaireMetadataHelper.getQuestionnaireMetadata)(currentQuestion, currentSelections, answers, skipMetadata);
    const nextQuestionIndex = getNextQuestionIndex(questions, currentQuestionIndex, metadata.flags, skippedQuestionIds);
    const id = `q-${currentQuestionIndex}`;
    const summary = (0, _questionSummaryHelper.getQuestionSummary)(currentQuestion, currentSelections);
    const time = new Date(Date.now());
    const description = currentQuestion.title;
    dispatch((0, _uiActions.updateTimestamp)([{
      id,
      time,
      description
    }]));
    dispatch((0, _questionnaireActions.gotoNextQuestion)({
      nextQuestionIndex,
      metadata,
      summary,
      id: currentQuestion.id
    }));
    if (nextQuestionIndex === _constants.RECOMMENDATION_PAGE_INDEX) {
      dispatch((0, _questionnaireActions.endQuestionnaire)());
    }
  };
  const onSkip = () => {
    const metadata = (0, _questionnaireMetadataHelper.getQuestionnaireMetadata)(currentQuestion, currentSelections, answers, skipMetadata);
    const nextQuestionIndex = getNextQuestionIndex(questions, currentQuestionIndex, metadata.flags, skippedQuestionIds);
    dispatch((0, _questionnaireActions.skipQuestion)(nextQuestionIndex));
    if (nextQuestionIndex === _constants.RECOMMENDATION_PAGE_INDEX) {
      dispatch((0, _questionnaireActions.endQuestionnaire)());
    }
  };
  return {
    onRestart,
    onBack,
    onNext,
    onSkip,
    onRestartWithWarningMessage,
    isRestartVisible: !isFirstQuestion,
    isBackVisible: !isFirstQuestion,
    isNextEnabled: hasValidSelections,
    numberOfQuestions: totalNumberOfJourneyQuestions,
    currentQuestionIndex: currentQuestionIndex,
    currentJourneyQuestionIndex: currentJourneyQuestionIndex + 1,
    nameOfJourney: nameOfJourney
  };
};
exports.useQuestionnaireNavigation = useQuestionnaireNavigation;
const useProgressPercentage = () => {
  const progressPercentage = (0, _useAppSelector.useAppSelector)(_questionnaireSelectors.selectQuestionnaireProgress);
  return {
    progressPercentage
  };
};
exports.useProgressPercentage = useProgressPercentage;